const configData =  {
    baseURL: 'https://app.vykazy.ki.fpv.ukf.sk',
    client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr"
}

export default configData